export const SearchTypeCart = 10 as const;
export type TSearchTypeCart = typeof SearchTypeCart;
